import { Link } from "../../../router/LocaleLink";
import { LinkedinOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Paths } from "../../../router/paths";
import styles from "./shariahMethodology.module.css";

import { usePageSEO } from "../../../components/SEO";
const ADVISOR_LINKEDIN =
  "https://www.linkedin.com/in/dr-muhamad-nezir-khan-csaa-7b9318227/";
const HALAL_WALLET_URL = "https://halalwallet.us/providers/akinda";

export default function ShariahScreeningMethodology() {
  usePageSEO("shariahScreeningMethodology");
  const { t } = useTranslation();
  const p = "pages.staticPages.shariahMethodology.";

  return (
    <article className={styles.page}>
      <header className={styles.hero}>
        <div className={styles.heroInner}>
          <p className={styles.eyebrow}>{t(`${p}eyebrow`)}</p>
          <h1 className={styles.heroTitle}>{t(`${p}heroTitle`)}</h1>
          <p className={styles.heroSubtitle}>{t(`${p}heroSubtitle`)}</p>
        </div>
      </header>

      <div className={styles.intro}>
        <p>
          {t(`${p}introPart1`)}
          <strong>{t(`${p}introAaofi`)}</strong>
          {t(`${p}introPart2`)}
        </p>
      </div>

      <div className={styles.trustCallout}>
        <p>
          {t(`${p}trustCalloutText`)}{" "}
          <a
            href={HALAL_WALLET_URL}
            target="_blank"
            rel="noopener"
            className={styles.trustCalloutLink}
          >
            HalalWallet
          </a>
          {t(`${p}trustCalloutSuffix`)}
        </p>
      </div>

      <section className={styles.section} aria-labelledby="data-heading">
        <h2 id="data-heading" className={styles.h2}>
          {t(`${p}dataHeading`)}
        </h2>
        <p className={styles.p}>{t(`${p}dataLead`)}</p>
        <div className={styles.dataGrid}>
          <div className={styles.dataCard}>
            <h3>{t(`${p}data1Title`)}</h3>
            <p>{t(`${p}data1Body`)}</p>
          </div>
          <div className={styles.dataCard}>
            <h3>{t(`${p}data2Title`)}</h3>
            <p>{t(`${p}data2Body`)}</p>
          </div>
        </div>
      </section>

      <section className={styles.section} aria-labelledby="phase1-heading">
        <div className={styles.phaseLabel}>
          <span className={styles.phaseNum}>1</span>
          {t(`${p}phaseLabel`)}
        </div>
        <h2 id="phase1-heading" className={styles.h2}>
          {t(`${p}phase1Title`)}
        </h2>
        <p className={styles.p}>{t(`${p}phase1P1`)}</p>
        <p className={styles.p}>
          <strong>{t(`${p}phase1P2Bold`)}</strong> {t(`${p}phase1P2Text`)}
        </p>
        <p className={styles.p}>
          <strong>{t(`${p}phase1P3Bold`)}</strong> {t(`${p}phase1P3Text`)}
        </p>
        <div className={styles.formulaBox}>
          <p className={styles.formulaTitle}>{t(`${p}formula`)}</p>
          <p className={styles.formula}>{t(`${p}formula5pct`)}</p>
          <p className={styles.note}>
            {t(`${p}note5pctBefore`)}
            <strong>{t(`${p}note5pctStrong`)}</strong>
            {t(`${p}note5pctAfter`)}
          </p>
        </div>
      </section>

      <section className={styles.section} aria-labelledby="phase2-heading">
        <div className={styles.phaseLabel}>
          <span className={styles.phaseNum}>2</span>
          {t(`${p}phaseLabel`)}
        </div>
        <h2 id="phase2-heading" className={styles.h2}>
          {t(`${p}phase2Title`)}
        </h2>
        <p className={styles.p}>{t(`${p}phase2P1`)}</p>
        <p className={styles.p}>
          <strong>{t(`${p}phase2P2Bold`)}</strong> {t(`${p}phase2P2Text`)}
        </p>
        <div className={styles.formulaBox}>
          <p className={styles.formulaTitle}>{t(`${p}avgMcapTitle`)}</p>
          <p className={styles.formula}>{t(`${p}avgMcapFormula`)}</p>
        </div>
        <p className={styles.p}>{t(`${p}phase2P3`)}</p>

        <div className={styles.ratioGrid}>
          <div className={styles.ratioCard}>
            <h3>{t(`${p}ratio1Title`)}</h3>
            <p className={styles.p} style={{ marginBottom: 8 }}>
              {t(`${p}ratio1Body`)}
            </p>
            <div className={styles.formulaBox} style={{ margin: 0 }}>
              <p className={styles.formulaTitle}>{t(`${p}formula`)}</p>
              <p className={styles.formula}>{t(`${p}ratio1Formula`)}</p>
            </div>
            <p className={styles.note}>{t(`${p}ratio1Note`)}</p>
          </div>

          <div className={styles.ratioCard}>
            <h3>{t(`${p}ratio2Title`)}</h3>
            <p className={styles.p} style={{ marginBottom: 8 }}>
              {t(`${p}ratio2Body`)}
            </p>
            <div className={styles.formulaBox} style={{ margin: 0 }}>
              <p className={styles.formulaTitle}>{t(`${p}formula`)}</p>
              <p className={styles.formula}>{t(`${p}ratio2Formula`)}</p>
            </div>
            <p className={styles.note}>{t(`${p}ratio2Note`)}</p>
          </div>
        </div>
      </section>

      <section className={styles.section} aria-labelledby="phase3-heading">
        <div className={styles.phaseLabel}>
          <span className={styles.phaseNum}>3</span>
          {t(`${p}phase3Label`)}
        </div>
        <h2 id="phase3-heading" className={styles.h2}>
          {t(`${p}phase3Title`)}
        </h2>
        <p className={styles.p}>{t(`${p}phase3P1`)}</p>
        <div className={styles.verdictGrid}>
          <div className={`${styles.verdict} ${styles.verdictHalal}`}>
            <span className={styles.verdictIcon} aria-hidden>
              ●
            </span>
            <h3>{t(`${p}verdictHalal`)}</h3>
            <p>{t(`${p}verdictHalalDesc`)}</p>
          </div>
          <div className={`${styles.verdict} ${styles.verdictHaram}`}>
            <span className={styles.verdictIcon} aria-hidden>
              ●
            </span>
            <h3>{t(`${p}verdictHaram`)}</h3>
            <p>{t(`${p}verdictHaramDesc`)}</p>
          </div>
          <div className={`${styles.verdict} ${styles.verdictDoubt}`}>
            <span className={styles.verdictIcon} aria-hidden>
              ●
            </span>
            <h3>{t(`${p}verdictDoubt`)}</h3>
            <p>{t(`${p}verdictDoubtDesc`)}</p>
          </div>
        </div>
        <div className={styles.purification}>
          <p>
            <strong>{t(`${p}purificationBold`)}</strong>{" "}
            {t(`${p}purificationText`)}
          </p>
        </div>
      </section>

      <section className={styles.advisor} aria-labelledby="advisor-heading">
        <div className={styles.advisorGrid}>
          <div className={styles.advisorPhotoWrap}>
            <div className={styles.advisorPhotoFrame}>
              <img
                className={styles.advisorPhoto}
                src="/shariah/muhammad-nazir-khan.webp"
                alt={t(`${p}advisorPhotoAlt`)}
                width={280}
                height={280}
              />
            </div>
          </div>
          <div className={styles.advisorBody}>
            <p className={styles.advisorKicker}>{t(`${p}advisorKicker`)}</p>
            <h2 id="advisor-heading" className={styles.advisorName}>
              {t(`${p}advisorName`)}
            </h2>
            <p className={styles.advisorBio}>{t(`${p}advisorBio`)}</p>
            <a
              className={styles.linkedin}
              href={ADVISOR_LINKEDIN}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedinOutlined style={{ fontSize: 18 }} aria-hidden />
              {t(`${p}linkedInProfile`)}
            </a>
          </div>
        </div>
      </section>

      <div className={styles.ctaTools}>
        <p>{t(`${p}ctaText`)}</p>
        <Link className={styles.ctaLink} to={Paths.SCREENING}>
          {t(`${p}ctaLink`)}
        </Link>
      </div>
    </article>
  );
}
